'use strict';
import React from 'react';
import AdFox from './AdFox';
import { ADFOX } from '../../consts';

const regions = {
  omsk: 'cjhn',
  kazan: 'cjoz',
  other: 'cjzq'
};

const positions = {
  [ADFOX.favoritesPage_1]: 'fwce',
  [ADFOX.favoritesPage_2]: 'fwcf'
};

const rubrics = {
  sale: {
    apartments: {
      [ADFOX.topWideScreenHome]: 'flmh',
      [ADFOX.topWideScreenSearch]: 'fpfq',
      [ADFOX.cardSidebar_1]: 'flub',
      [ADFOX.cardSidebar_2]: 'fluc',
      [ADFOX.cardSidebar_3]: 'fmix',
      [ADFOX.listingGrid_1]: 'fldo',
      [ADFOX.listingGrid_2]: 'flnb',
      [ADFOX.listingGrid_3]: 'flwu',
      [ADFOX.listingGrid_4]: 'flwv',
      [ADFOX.listingFooter]: 'flnc',
      [ADFOX.homeAliasMenu]: 'fltz',
      [ADFOX.homeBuilder]: 'ftvq',
      [ADFOX.homeSplitter_1]: 'fxoq',
      [ADFOX.homeSplitter_2]: 'fxoq',
      [ADFOX.homeSplitter_3]: 'fxoq',
      [ADFOX.homeFooter]: 'fxoq'
    },
    lands: {
      [ADFOX.topWideScreenHome]: 'flnw',
      [ADFOX.topWideScreenSearch]: 'fpug',
      [ADFOX.cardSidebar_1]: 'fltt',
      [ADFOX.cardSidebar_2]: 'fltu',
      [ADFOX.cardSidebar_3]: 'fmpc',
      [ADFOX.listingGrid_1]: 'floc',
      [ADFOX.listingGrid_2]: 'flny',
      [ADFOX.listingGrid_3]: 'flwx',
      [ADFOX.listingGrid_4]: 'flwy',
      [ADFOX.listingFooter]: 'floa',
      [ADFOX.homeSplitter_1]: 'fygd',
      [ADFOX.homeSplitter_2]: 'fygd',
      [ADFOX.homeSplitter_3]: 'fygd',
      [ADFOX.homeFooter]: 'fygd'
    },
    commercials: {
      [ADFOX.topWideScreenHome]: 'flnx',
      [ADFOX.topWideScreenSearch]: 'fpuh',
      [ADFOX.cardSidebar_1]: 'fltx',
      [ADFOX.cardSidebar_2]: 'flty',
      [ADFOX.cardSidebar_3]: 'fmpd',
      [ADFOX.listingGrid_1]: 'flod',
      [ADFOX.listingGrid_2]: 'flnz',
      [ADFOX.listingGrid_3]: 'flwz',
      [ADFOX.listingGrid_4]: 'flxa',
      [ADFOX.listingFooter]: 'flob',
      [ADFOX.homeSplitter_1]: 'fyge',
      [ADFOX.homeFooter]: 'fyge'
    },
    garages: {
      [ADFOX.topWideScreenHome]: 'fmfa',
      [ADFOX.topWideScreenSearch]: 'fpuf',
      [ADFOX.cardSidebar_1]: '',
      [ADFOX.cardSidebar_2]: '',
      [ADFOX.cardSidebar_3]: '',
      [ADFOX.listingGrid_1]: 'fmfh',
      [ADFOX.listingGrid_2]: 'fmfi',
      [ADFOX.listingGrid_3]: 'fmfj',
      [ADFOX.listingGrid_4]: 'fmfk',
      [ADFOX.listingFooter]: 'fmfl',
      [ADFOX.homeSplitter_1]: 'fygc',
      [ADFOX.homeFooter]: 'fygc'
    }
  },
  rent: {
    commercials: {
      [ADFOX.topWideScreenSearch]: 'fpuh',
      [ADFOX.cardSidebar_1]: 'fltx',
      [ADFOX.cardSidebar_2]: 'flty',
      [ADFOX.cardSidebar_3]: 'fmpd',
      [ADFOX.listingGrid_1]: 'flod',
      [ADFOX.listingGrid_2]: 'flnz',
      [ADFOX.listingGrid_3]: 'flwz',
      [ADFOX.listingGrid_4]: 'flxa',
      [ADFOX.listingFooter]: 'flob'
    },
    apartments: {
      [ADFOX.topWideScreenSearch]: 'fpue',
      [ADFOX.cardSidebar_1]: 'fmei',
      [ADFOX.cardSidebar_2]: 'fmeh',
      [ADFOX.cardSidebar_3]: 'fmpa',
      [ADFOX.listingGrid_1]: 'fmek',
      [ADFOX.listingGrid_2]: 'fmel',
      [ADFOX.listingGrid_3]: 'fmem',
      [ADFOX.listingGrid_4]: 'fmen',
      [ADFOX.listingFooter]: 'fmeo'
    }
  },
  rentDaily: {
    apartments: {
      [ADFOX.topWideScreenSearch]: 'fpue',
      [ADFOX.cardSidebar_1]: 'fmei',
      [ADFOX.cardSidebar_2]: 'fmeh',
      [ADFOX.cardSidebar_3]: 'fmpa',
      [ADFOX.listingGrid_1]: 'fmek',
      [ADFOX.listingGrid_2]: 'fmel',
      [ADFOX.listingGrid_3]: 'fmem',
      [ADFOX.listingGrid_4]: 'fmen',
      [ADFOX.listingFooter]: 'fmeo'
    }
  }
};

function AdFoxFactory (domain) {
  const regionId = regions[domain] || regions.other;
  const prefix = 'adfox_';

  const getConfigBySection = function (position, dealType, realtyType, config = {}, containerId = '') {
    const index = config.index || '';
    const onRender = config.onRender || (() => {});
    const onError = config.onError || (() => {});
    const onStub = config.onStub || (() => {});

    const id = prefix + dealType + '_' + realtyType + '_' + position + (index ? '_' + index : '');
    const className = `adfox-${position} adfox-${position + (index ? '_' + index : '')}`;
    const placeId = rubrics[dealType][realtyType][position] || '';

    return {
      id: containerId || id,
      key: containerId || id,
      index,
      placeId,
      regionId,
      className,
      onRender,
      onError,
      onStub
    };
  };

  return {
    getConfigBySection,

    getBySection: function (position, dealType, realtyType, config = {}, containerId = '') {
      if (!position) {
        return null;
      }

      const params = getConfigBySection(position, dealType, realtyType, config, containerId);

      return params.placeId ? (
        <AdFox
          id={params.id}
          key={params.key}
          className={params.className}
          regionId={params.regionId}
          placeId={params.placeId}
          onRender={params.onRender}
          onError={params.onError}
          onStub={params.onStub} />
      ) : null;
    },

    getByPosition: function (position, config = {}, containerId = '') {
      if (!position) {
        return null;
      }

      const index = config.index || '';
      const onRender = config.onRender || (() => {});
      const onError = config.onError || (() => {});
      const onStub = config.onStub || (() => {});

      const id = prefix + position + (index ? '_' + index : '');
      const placeId = positions[position] || '';

      return placeId ? (
        <AdFox
          id={containerId || id}
          key={containerId || id}
          regionId={regionId}
          placeId={placeId}
          onRender={onRender}
          onError={onError}
          onStub={onStub} />
      ) : null;
    }
  };
}

AdFoxFactory.getListingGridPosition = function (index) {
  const adFoxIndex = 'listingGrid_' + index;

  return ADFOX[adFoxIndex] || null;
};

export default AdFoxFactory;



// WEBPACK FOOTER //
// ./src/ui/AdFox/AdFoxFactory.jsx